import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-articles-sort',
  templateUrl: './articles-sort.component.html',
  styleUrls: ['./articles-sort.component.css'],
  standalone: false,
})
export class ArticlesSortComponent {
  @Input() sortBy = 'updatedAt_desc';
  @Output() sortParamSelected = new EventEmitter();

  public valueChanged(): void {
    switch (this.sortBy) {
      case 'deadline_asc':
        this.sortParamSelected.emit({
          sortBy: 'deadline',
          descending: false,
        });
        break;
      case 'deadline_desc':
        this.sortParamSelected.emit({
          sortBy: 'deadline',
          descending: true,
        });
        break;
      case 'updatedAt_desc':
      default:
        this.sortParamSelected.emit({
          sortBy: 'updatedAt',
          descending: true,
        });
        break;
      case 'updatedAt_asc':
        this.sortParamSelected.emit({
          sortBy: 'updatedAt',
          descending: false,
        });
        break;
      case 'A-Z':
        this.sortParamSelected.emit({
          sortBy: 'title',
          descending: false,
        });
        break;
      case 'Z-A':
        this.sortParamSelected.emit({
          sortBy: 'title',
          descending: true,
        });
        break;
    }
  }
}
